<script setup lang="ts">
import type { IconName } from '~/components/ui/Icon.vue';

export interface ActionListItem {
  title: string;
  to: string;
  icon: IconName;
  iconForeground: string;
  iconBackground: string;
  description?: string;
}

defineProps<{
  actions: ActionListItem[];
}>();
</script>
<template>
  <div
    class="divide-y divide-gray-200 overflow-hidden rounded-lg border border-gray-200 bg-gray-200 sm:grid sm:grid-cols-2 sm:gap-px sm:divide-y-0"
  >
    <nuxt-link
      v-for="(action, actionIdx) in actions"
      :key="action.title"
      :to="action.to"
      class="cursor-pointer"
      :class="[
        actionIdx === 0 ? 'rounded-tl-lg rounded-tr-lg sm:rounded-tr-none' : '',
        actionIdx === 1 ? 'sm:rounded-tr-lg' : '',
        actionIdx === actions.length - 2 ? 'sm:rounded-bl-lg' : '',
        actionIdx === actions.length - 1 ? 'rounded-bl-lg rounded-br-lg sm:rounded-bl-none' : '',
        'group relative bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500',
      ]"
    >
      <div>
        <span :class="[action.iconBackground, action.iconForeground, 'inline-flex rounded-lg p-3 ring-4 ring-white']">
          <ui-icon :name="action.icon" class="size-6" />
        </span>
      </div>
      <div class="mt-8">
        <h3 class="text-base font-semibold text-gray-900">
          <p class="focus:outline-none">
            {{ action.title }}
          </p>
        </h3>
        <p v-if="action.description" class="mt-2 text-sm text-gray-500">
          {{ action.description }}
        </p>
      </div>
      <span class="pointer-events-none absolute right-6 top-6 text-gray-300 group-hover:text-gray-400" aria-hidden="true">
        <ui-icon name="ArrowUpRight" class="size-6" />
      </span>
    </nuxt-link>
  </div>
</template>
